
import { Options, Vue } from "vue-class-component";
import { useStore } from "../store";
import { MutationTypes } from "../store/mutation-types";
import { filterData } from "../data/functions";

@Options({
  props: {
    text: Array,
  },
  data() {
    return {
      firstIndex: 0,
      currentDaySection: 0,
      // @ts-ignore
      dayDisplay: this.text.slice(0, 4),
    };
  },
  computed: {
    leftArrow: function () {
      return this.firstIndex > 0;
    },
    rightArrow: function () {
      return this.text.length > this.firstIndex + 4 ? true : false;
    },
  },
  mounted() {
    this.activeButton(0, this.text[0]);
  },
  methods: {
    // .menu: 0 for PAR LIEU, 1 for PAR HEURE
    activeButton(value: number, text: string) {
      const currentMenuValue = this.$store.state.activeDayMenu.menu;
      const data = { number: value, filter: text, menu: currentMenuValue };
      // pushes to the store the active menu and button text
      return this.$store.commit(MutationTypes.SET_DAY_MENU, data);
    },
    // determines the css
    chooseDisplay(index: number) {
      return this.$store.state.activeDayMenu.number === index
        ? "btn-active"
        : "btn";
    },
    // switch days when needed
    handleClick(arrow: string) {
      if (arrow === "right") {
        return this.firstIndex + 5 <= this.text.length
          ? ((this.firstIndex = this.firstIndex + 4),
            (this.rightArrow = true),
            (this.dayDisplay = this.text.slice(
              this.firstIndex,
              this.firstIndex + 4
            )))
          : (this.rightArrow = false);
      }
      if (arrow === "left") {
        return (
          (this.firstIndex = this.firstIndex - 4),
          (this.dayDisplay = this.text.slice(
            this.firstIndex,
            this.firstIndex + 4
          ))
        );
      }
    },
  },
})
export default class ScheduleDayMenuButtons extends Vue {
  store = useStore();
  filterData = filterData;
  text!: string[];
}
